const SessionUpdater = (function () {
    let clientMovedSinceLastTimeout = false;
    let keepSessionAliveUrl:string = null;
    let timeout;
    let keepAliveTimer;

    function setupSessionUpdater(actionUrl, timeoutTimeKeepAlive) {
        // Timeout keep-alive init
        if (timeoutTimeKeepAlive == null || timeoutTimeKeepAlive == 'undefined' || timeoutTimeKeepAlive == 0)
            timeout = 5 * 1000 * 60; // 5 minutes
        else
            timeout = timeoutTimeKeepAlive; // timeout defined
        // Store local value
        keepSessionAliveUrl = actionUrl;

        // Setup handlers
        listenForChanges();
        // Start timeout - it'll run after n minutes
        checkToKeepSessionAlive();
    }

    function listenForChanges() {
        $(document).one("mousemove keydown", function () {
            clientMovedSinceLastTimeout = true;
        });
    }

    // fires every n minutes - if there's been movement ping server and restart timer
    function checkToKeepSessionAlive() {
        if (keepAliveTimer != null && keepAliveTimer != 'undefined' && keepAliveTimer != 0)
            clearTimeout(keepAliveTimer);
        keepAliveTimer = setTimeout(function () { keepSessionAlive(); }, timeout);
    }

    function keepSessionAlive() {
        // if we've had any movement since last run, ping the server
        if (clientMovedSinceLastTimeout && keepSessionAliveUrl != null) {
            $.ajax({
                type: "POST",
                url: keepSessionAliveUrl,
                success: function (data) {
                    checkToKeepSessionAlive();
                },
                error: function (data) {
                    console.error("Error posting to " + keepSessionAliveUrl);
                }
            });
        }
    }

    // export setup method
    return {
        Setup: setupSessionUpdater
    };

})();